import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromRoot from '@app/store/reducers';
import * as fromCart from './cart.reducer';

export interface CartState {
  status: fromCart.State;
}

export interface State extends fromRoot.IAppState {
  cart: CartState;
}

export const reducers: ActionReducerMap<CartState> = {
  status: fromCart.reducer
};

export const selectCartState = createFeatureSelector<CartState>('cart');

export const selectCartStatusState = createSelector(selectCartState, (state: CartState) => state.status);

export const getCurrentCart = createSelector(selectCartStatusState, fromCart.getOrder);
export const getCartPending = createSelector(selectCartStatusState, fromCart.getPending);
